import React from "react";
import PropTypes from "prop-types";
import { GET } from "lib/api";
import config from "lib/config";
import LuvitComponent from "LuvitComponent";
import CoworkersInUnitDropDown from "lib/components/CoworkersInUnitDropDown";
import { autobind } from "lib/decorators";
import { observer } from "mobx-react";
import UserStore from "stores/user";
import { getTmPages } from "lib/rightsmanager";
import SelectionStore from "../../../stores/teams";
import * as TeamFunctionRights from "../../constants/teamfunctionrights";
import SelectionDropDown from "../managerSelect";
import * as MainMenu from "../../constants/mainmenu";
import SettingStore from "stores/settings";
import _ from "lodash";
import { Grid } from "Components/Base/Layout/Grid";

const pId = config.personalId;
const COWORKERS_API = "v1/units/:unitId/coworkers/";

@observer
export default class CoworkerHeader extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "Menu");
    this.changePage = this.changePage.bind(this);
    this.updateSelectedPage = this.updateSelectedPage.bind(this);
  }

  updateSelectedPage() {
    let href = document.location.href;

    let personalId = luvit.GetQueryString("id");
    if (personalId && personalId !== this.state.personalId) {
      this.setState({ personalId });
    }

    let page = this.state.pages.find((a) => href.indexOf(a.url) >= 0);
    page && page.url && this.setState({ selectedPage: page.url });
  }

  async componentWillMount() {
    let state = { ready: true };
    this.setState(state);

    window.addEventListener("hashchange", this.updateSelectedPage);

    SelectionStore.updateTeamFilter(TeamFunctionRights.FILTER_SHOWALL);
    this.setActiveSelectionFromQueryString();
    const isBt = SettingStore.isBt();
    const personalId = luvit.GetQueryString("id");
    let pages = await getTmPages();

    if (personalId) {
      state = {
        ...state,
        manager: true,
        unit: this.getActiveUnitId(),
        personalId,
      };
      const manager = true;
      const mode = pId != personalId ? "m" : "c";
      this.setState({
        manager,
        unit: this.getActiveUnitId(),
        mode,
        personalId,
        isBt,
      });
    }

    if (this.isPageSelectionValid(document.location.href, pages)) {
      this.setState({ pages }, this.updateSelectedPage);
    } else {
      this.setState({ pages }, this.changePage);
    }

    if (!UserStore.user.fromAdmin) {
      await this.getCoworkers();
    }

    this.filterTeamsForCurrentPage();
  }

  componentWillUnmount() {
    window.removeEventListener("hashchange", this.updateSelectedPage);
  }

  changePage() {
    let hash = null;
    if (this.refs.pageSelect && this.refs.pageSelect.value) {
      hash = this.refs.pageSelect.value;
    } else if (this.state.pages && this.state.pages.length > 0) {
      hash = this.state.pages[0].url;
    } else {
      hash = "";
    }

    let qs = document.location.href.split("?");

    if (qs.length > 1) {
      hash += "?" + qs[1];
    }

    if (hash && hash[0] == "/") {
      hash = hash.substr(1);
    }

    document.location.href = this.path + hash;
  }

  isPageSelectionValid(href, pages) {
    let page = pages.find((a) => href.indexOf(a.url) >= 0);
    return page ? true : false;
  }

  isManager() {
    return !!(
      luvit.GetQueryString("u") ||
      !!luvit.GetQueryString("t") ||
      luvit.GetQueryString("user")
    );
  }

  @autobind
  async onSelectionChange(newSelection) {
    const [type, id] = newSelection.split("-");
    SelectionStore.activateSelection(id, type);

    let coworkers = await this.getCoworkers();

    const activePersonalId = coworkers[0] ? coworkers[0].personalID : "";
    this.updateQueryString(activePersonalId);

    let pages = await getTmPages();
    this.setState({ pages });
  }

  @autobind
  onCoworkerChange(event) {
    const newActivePersonalId = event.target.value;
    this.updateQueryString(newActivePersonalId);
  }

  translateBtPhrases(menuName) {
    if (this.state.isBt) {
      if (menuName == "competenceprofile") return this.l("subgoalfullfillment");

      if (menuName == "developmentplan") return this.l("activities2");

      if (menuName == "mylearning") return this.l("programsandprogress");
    }

    return this.l(menuName);
  }

  doRender() {
    const { coworkers } = this.state;
    const managerView = this.props.showUnits !== false && this.isManager();

    return (
      <Grid
        container
        style={{ rowGap: "8px", columnGap: "16px" }}
        alignItems="center"
      >
        {managerView && (
          <Grid item>
            <a
              href={this.path + "#/tm/manager/dashboard"}
              title={this.l("overview")}
              aria-label={this.l("overview")}
            >
              <span
                className="fa fa-home"
                aria-hidden="true"
                style={{ fontSize: "32px" }}
              />
            </a>
          </Grid>
        )}
        {managerView && (
          <Grid item>
            <SelectionDropDown
              selection={SelectionStore.active}
              onChange={(selection) => this.onSelectionChange(selection.value)}
              selections={SelectionStore.list}
            />
          </Grid>
        )}
        {managerView && (
          <Grid item>
            <CoworkersInUnitDropDown
              coworkers={coworkers}
              onChange={this.onCoworkerChange}
              coworkerId={this.state.personalId}
            />
          </Grid>
        )}
        <Grid item>
          <select
            name="manager-selected-page"
            aria-label="manager-selected-page"
            value={this.state.selectedPage}
            onChange={this.changePage}
            ref="pageSelect"
          >
            {this.state.pages &&
              this.state.pages.map((p, i) => (
                <option key={i} value={p.url}>
                  {" "}
                  {this.translateBtPhrases(p.name)}{" "}
                </option>
              ))}
          </select>
        </Grid>
      </Grid>
    );
  }

  async getCoworkers() {
    let coworkers = [];
    const id = SelectionStore.active.id;
    switch (SelectionStore.active.type) {
      case "unit":
        coworkers = await GET(COWORKERS_API, { unitId: id });
        break;
      case "team":
        coworkers = await GET("v1/team/:teamId/members/", { teamId: id });
        break;
      default:
        throw new Error("Unknown type of selection.");
    }

    this.setState({ coworkers });
    return coworkers;
  }

  setActiveSelectionFromQueryString() {
    const unitId = luvit.GetQueryString("u");
    const teamId = luvit.GetQueryString("t");

    if (unitId) {
      SelectionStore.activateSelection(unitId, "unit");
    } else if (teamId) {
      SelectionStore.activateSelection(teamId, "team");
    }
  }

  updateQueryString(activePersonalId) {
    const url = document.location.href.split("?")[0];
    const id = SelectionStore.active.id;
    switch (SelectionStore.active.type) {
      case "unit":
        document.location.href = url + "?u=" + id + "&id=" + activePersonalId;
        break;
      case "team":
        document.location.href = url + "?t=" + id + "&id=" + activePersonalId;
        break;
      default:
        throw new Error("Unknown type of selection.");
    }
  }

  getActiveUnitId() {
    if (!this.isManager()) {
      return -1;
    }

    switch (SelectionStore.active.type) {
      case "unit":
        return SelectionStore.active.id;
      case "team":
        return SelectionStore.active.unitId;
      default:
        throw new Error("Unknown type of selection.");
    }
  }

  filterPagesForCoworkerDropdown(pages) {
    return pages.filter(
      (m) => m.section === "TM" && m.itemId !== MainMenu.ID_COWORKER_ENGAGEMENT,
    );
  }

  filterPagesForCurrentTeam(pages) {
    if (SelectionStore.active.type !== "team") {
      return pages;
    }

    const permissions = SelectionStore.active.permissions;

    if (permissions.indexOf(TeamFunctionRights.ID_COMPTALK) !== -1) {
      return pages;
    }

    return pages.filter(
      (m) =>
        (m.itemId === MainMenu.ID_COWORKER_CAREERPATHS &&
          permissions.indexOf(TeamFunctionRights.ID_COMPETENCEMANAGEMENT) !==
            -1) ||
        (m.itemId === MainMenu.ID_COWORKER_COMPETENCEPROFILE &&
          permissions.indexOf(TeamFunctionRights.ID_COMPETENCEMANAGEMENT) !==
            -1) ||
        (m.itemId === MainMenu.ID_COWORKER_CERTIFICATES &&
          permissions.indexOf(TeamFunctionRights.ID_COMPETENCEMANAGEMENT) !==
            -1) ||
        (m.itemId === MainMenu.ID_COWORKER_MYCOURSES &&
          (permissions.indexOf(TeamFunctionRights.ID_COURSESTATISTICS) !== -1 ||
            permissions.indexOf(TeamFunctionRights.ID_REGISTERANDCANCEL) !==
              -1)) ||
        (m.itemId === MainMenu.ID_COWORKER_AUTHORISATIONS &&
          permissions.indexOf(TeamFunctionRights.ID_COMPETENCEMANAGEMENT) !==
            -1) ||
        (m.itemId === MainMenu.ID_COWORKER_EDUCATIONHISTORYANDCV &&
          permissions.indexOf(TeamFunctionRights.ID_COURSESTATISTICS) !== -1) ||
        (m.itemId === MainMenu.ID_COWORKER_MYACTIVITIES &&
          permissions.indexOf(TeamFunctionRights.ID_REGISTERANDCANCEL) !==
            -1) ||
        (m.itemId === MainMenu.ID_COWORKER_GOALSANDACTIVITIES &&
          permissions.indexOf(TeamFunctionRights.ID_GOALSANDACTIVITIES) !==
            -1) ||
        (m.itemId === MainMenu.ID_COWORKER_DEVELOPMENTPLAN &&
          permissions.indexOf(TeamFunctionRights.ID_GOALSANDACTIVITIES) !== -1),
    );
  }

  filterTeamsForCurrentPage() {
    switch (this.props.href) {
      case "#/tm/coworker/personalgoals/goals":
      case "#/tm/coworker/personalgoals/goal":
      case "#/tm/coworker/personalgoals/developmentplan":
        SelectionStore.updateTeamFilter([
          TeamFunctionRights.ID_COMPTALK,
          TeamFunctionRights.ID_GOALSANDACTIVITIES,
        ]);
        return;
      case "#/tm/coworker/dashboard":
      case "#/tm/coworker/comptalk":
      case "#/tm/coworker/documents":
      case "#/tm/coworker/personalprofile":
        SelectionStore.updateTeamFilter([TeamFunctionRights.ID_COMPTALK]);
        return;
      case "#/tm/coworker/mycourses":
        SelectionStore.updateTeamFilter([
          TeamFunctionRights.ID_COMPTALK,
          TeamFunctionRights.ID_COURSESTATISTICS,
          TeamFunctionRights.ID_REGISTERANDCANCEL,
        ]);
        return;
      case "#/tm/coworker/careerpath":
      case "#/tm/coworker/competenceprofile":
      case "#/tm/coworker/certificates":
      case "#/tm/coworker/authorisations":
        SelectionStore.updateTeamFilter([
          TeamFunctionRights.ID_COMPTALK,
          TeamFunctionRights.ID_COMPETENCEMANAGEMENT,
        ]);
        return;
      case "#/tm/coworker/completedcourses":
        SelectionStore.updateTeamFilter([
          TeamFunctionRights.ID_COMPTALK,
          TeamFunctionRights.ID_COURSESTATISTICS,
        ]);
        return;
      case "#/tm/coworker/courseapplications":
        SelectionStore.updateTeamFilter([
          TeamFunctionRights.ID_COMPTALK,
          TeamFunctionRights.ID_REGISTERANDCANCEL,
        ]);
        return;
      default:
        break;
    }

    if (this.props.href.indexOf("#/tm/coworker/comptalk") > -1) {
      SelectionStore.updateTeamFilter(TeamFunctionRights.ID_COMPTALK);
      return;
    }

    SelectionStore.updateTeamFilter(TeamFunctionRights.FILTER_SHOWNONE);
  }
}

CoworkerHeader.propTypes = {
  activeNode: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  profileView: PropTypes.bool,
  tree: PropTypes.object,
  nodes: PropTypes.arrayOf(PropTypes.any),
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  updateTree: PropTypes.func,
  selectTree: PropTypes.func,
  updateNodeHeader: PropTypes.func,
  treesInfo: PropTypes.arrayOf(PropTypes.object),
};

CoworkerHeader.defaultProps = {
  activeNode: "",
  profileView: false,
};
